import React from 'react';
import PropTypes from 'prop-types';
import { LargeMobile } from 'Responsive';
import CalculatorInput from 'CalculatorInput';
import TotalView from './TotalView';

const CostsInputs = props => (
  <React.Fragment>
    <CalculatorInput
      title="Rent and utilities"
      description={'Expenses you pay for your home on a monthly basis (electric, lights, wifi, etc.).'}
      onChange={e => props.onChange(e, 0)}
      value={props.values[0]}
      className="startup-calculator-input-wrap"
      type="monetary"
    />
    <CalculatorInput
      title="Payroll"
      description={'What you pay your employees.'}
      onChange={e => props.onChange(e, 1)}
      value={props.values[1]}
      className="startup-calculator-input-wrap"
      type="monetary"
    />
    <CalculatorInput
      title="Inventory and equipment"
      description={'Supplies whose expenses carry through month to month (paper shipments, etc.).'}
      onChange={e => props.onChange(e, 2)}
      value={props.values[2]}
      className="startup-calculator-input-wrap"
      type="monetary"
    />
    <CalculatorInput
      title="Marketing"
      description={'Cost of ads, featuring the project in magazines, social media, etc.'}
      onChange={e => props.onChange(e, 3)}
      value={props.values[3]}
      className="startup-calculator-input-wrap"
      type="monetary"
    />
    <CalculatorInput
      title="Other Costs"
      description=""
      onChange={e => props.onChange(e, 4)}
      value={props.values[4]}
      className="startup-calculator-input-wrap startup-calculator-final-input"
      type="monetary"
    />
    <LargeMobile>
      <TotalView
        title="Total Recurring Costs"
        sum={props.sum}
        back={props.back}
        next={props.next}
        backText="Assets"
        nextText="Total Costs"
      />
    </LargeMobile>
  </React.Fragment>
);

CostsInputs.defaultProps = {
  back: null,
  next: null,
};

CostsInputs.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  sum: PropTypes.string.isRequired,
  back: PropTypes.func,
  next: PropTypes.func,
};

export default CostsInputs;



// WEBPACK FOOTER //
// ./src-react/StartupCalculator/components/CostsInputs.jsx